import React from 'react';
import PropTypes from 'prop-types';
import { MessageType } from '../../types';

import './styles.css';
import { formatRoute } from 'react-router-named-routes';
import InboxMessageHeader from '../InboxMessageHeader';
import { NavLink } from 'react-router-dom';
import { MESSAGE } from '../../routes';

const InboxMessagePreview = ({ game, message, readEmail }) => (
	<li
		className={`${message.isRead ? 'isRead' : ''} inbox-message-preview`}
		onClick={() => {
			!message.isRead && readEmail();
		}}
	>
		<NavLink
			to={formatRoute(MESSAGE, { messageID: message.id, gameID: game.id })}
		>
			<InboxMessageHeader message={message} />
			<h4>{message.subject}</h4>
			<p className="light-color regular-font">{message.message}</p>
		</NavLink>
	</li>
);

InboxMessagePreview.propTypes = {
	message: MessageType.isRequired,
	readEmail: PropTypes.func
};

export default InboxMessagePreview;
